@if (message) {
<div
  [attr.role]="toastType === 'error' ? 'alert' : 'status'"
  class="relative z-[150] w-full mobile:w-auto sm:max-w-[460px] pl-[18px] pr-6 py-3 rounded-lg text-white bg-black-dark-light shadow-[0_10px_30px_rgba(0,0,0,0.35)] backdrop-blur-md overflow-hidden"
  [ngClass]="combinedClasses"
  [style.transform]="toastTransform"
  [style.opacity]="toastOpacity"
  [style.transition]="swipeTransition"
  style="touch-action: pan-y"
  (pointerdown)="onPointerDown($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerCancel($event)"
>
  <span
    class="absolute left-0 top-0 bottom-0 w-[6px] rounded-l-lg"
    [style.background]="accentColor"
    [style.opacity]="0.8"
  ></span>

  <div
    class="relative flex items-start gap-3"
    [ngClass]="{'gap-[22px]': toastType === 'info'}"
  >
    <span
      class="shrink-0 w-[18px] h-[18px] mask-size-[18px_18px]"
      [ngClass]="{
        'mask-[url(/assets/images/icons/check.svg)]': toastType === 'success',
        'mask-[url(/assets/images/icons/error.svg)]': toastType === 'error',
        'mask-[url(/assets/images/icons/alert.svg)]': toastType === 'warning',
        'w-[22px] h-[22px] mask-[url(/assets/images/icons/info.svg)] mask-size-[22px_22px]':
          toastType === 'info'
      }"
      [style.background]="accentColor"
    ></span>

    <div class="flex-1 min-w-0">
      <div class="font-bold text-base leading-tight text-white">
        @if (offline) {
        <span class="inline-flex items-center gap-2">
          <span
            class="block w-[18px] h-[18px] bg-white mask-[url(/assets/images/icons/offline.svg)] mask-size-[18px_18px] mask-no-repeat mask-center"
          ></span>
          @if (translatable) {
          {{ message | translate }}
          } @else {
          {{ message }}
          }
        </span>
        } @else { @if (translatable) {
        {{ message | translate }}
        } @else {
        {{ message }}
        } }
      </div>
      @if (toast && toast.actionLabel && toast.onAction) {
      <button
        type="button"
        class="mt-1 min-h-[32px] font-bold text-white underline underline-offset-4 cursor-pointer"
        (click)="runAction()"
        [disabled]="toast.busy"
      >
        {{ toast.actionLabel | translate }}
      </button>
      } @if (toast && toast.detail; as detail) {
      <p class="mt-1 mb-0 text-sm text-white" role="status">
        {{ detail | translate }}
      </p>
      } @if (toast && toast.choices?.length) {
      <div class="mt-1 flex flex-wrap gap-0.5">
        @for (choice of toast.choices; track choice.label) {
        <button
          type="button"
          class="min-h-[36px] rounded-full border border-white/40 px-1 text-sm text-white hover:bg-white/15 disabled:opacity-50"
          [disabled]="toast.busy"
          (click)="choice.onSelect()"
        >
          {{ choice.label | translate }}
        </button>
        }
      </div>
      }
    </div>
  </div>

  <div
    class="absolute w-full left-[5px] bottom-0 h-[3px] rounded-full bg-white/10 overflow-hidden"
  >
    <span
      class="absolute left-0 top-0 h-full w-full origin-left opacity-40 animate-toast-progress"
      [style.background]="accentGradient"
      [style.animation-duration.ms]="durationMs"
    ></span>
  </div>

  @if (!offline && toast) {
  <button
    (click)="closeToast()"
    type="button"
    [attr.aria-label]="'CLOSE_MODAL' | translate"
    tabindex="0"
    class="absolute top-0.5 right-0.5 w-4 h-4 rounded-full hover:bg-white/10 flex items-center justify-center cursor-pointer"
  >
    <span
      class="block w-[12px] h-[12px] bg-white mask-[url(/assets/images/icons/close.svg)] mask-size-[12px_12px] mask-no-repeat mask-center"
    ></span>
  </button>
  }
</div>
}
